import {gql} from '@apollo/client/core';

export const GET_POINT_DETAILS = gql`
    query PointDetails(
        $filters: PointDetailFiltersInput
        $pagination: PaginationArg
    ) {
        pointDetails(filters: $filters, pagination: $pagination) {
            documentId
            point
            tour_match {
                match_code
            }
            tour_player_team {
                documentId
                player_1 {
                    first_name
                    last_name
                    middle_name
                }
                player_2 {
                    first_name
                    last_name
                    middle_name
                }
            }
            category {
                documentId
                name
            }
            player {
                documentId
                first_name
                last_name
                middle_name
            }
            tour_match {
                match_code
            }
            round {
                documentId
                name
                category {
                    name
                }
            }
        }
    }
`;

export const GET_POINT_DETAILS_PAGINATE = gql`
    query GetPointDetails($page: Int!, $pageSize: Int!, $filters: PointDetailFiltersInput) {
        pointDetails_connection(
            pagination: { page: $page, pageSize: $pageSize }
            filters: $filters
            sort: ["point:desc"]
        ) {
            nodes {
                documentId
                point
                tour_match {
                    match_code
                }
                tour_player_team {
                    documentId
                    player_1 {
                        first_name
                        last_name
                        middle_name
                    }
                    player_2 {
                        first_name
                        last_name
                        middle_name
                    }
                }
                category {
                    documentId
                    name
                }
                player {
                    documentId
                    first_name
                    last_name
                    middle_name
                }
                tour_match {
                    match_code
                }
                round {
                    documentId
                    name
                    category {
                        name
                    }
                }
            }
            pageInfo {
                page
                pageCount
                pageSize
                total
            }
        }
    }
`;

export const GET_POINT_DETAILS_BY_PLAYER = gql`
    query PointDetails_connection($documentId: ID!) {
        pointDetails_connection(
            filters: {
                player: {
                    documentId: {
                        eq: $documentId
                    }
                }
            }
        ) {
            nodes {
                total_wins
                points_won
                points_lost
                point
                sets_lost
                sets_won
                total_losses
            }
        }
    }
`;